var map = {
	"./1_Jan_Kowalski.png": 9209,
	"./2_Anna_Jung.png": 6797,
	"./3_Piotr_Darba.png": 8090,
	"./4 _iotr_Nowak.png": 5302,
	"./5_Piotr_Klimas.png": 1774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5520;